const mobileSwapWidth = 1024
let isVisible         = false
let wrapEl            = null
let navEl             = null
let allDesc           = null
let openBtn           = null
let closeBtn          = null
let mobileVpWidth     = null


export function initialize() {
  openBtn  = document.querySelector('[data-open-nav]')
  closeBtn = document.querySelector('[data-close-nav]')
  wrapEl   = document.querySelector('[data-nav-wrap]')
  navEl    = document.querySelector('[data-nav-el]')

  if (!openBtn || !closeBtn || !wrapEl || !navEl) {
    return
  }

  allDesc = wrapEl.getElementsByTagName('*')
  addListeners()
  betterResize()
}


export function addListeners() {
  openBtn.addEventListener('click', toggleNav, false)
  closeBtn.addEventListener('click', toggleNav, false)
  document.addEventListener('touchend', determineEventLoc, false)
  document.addEventListener('click', determineEventLoc, false)
  document.addEventListener('keyup', handleKeyPresses, false)
  window.addEventListener('resizeViaRAF', handleResize, false)
}


export function betterResize() {
  let running = false

  function doItViaRAF() {
    if (running) {return}
    running = true
    requestAnimationFrame(function() {
      window.dispatchEvent(new CustomEvent('resizeViaRAF'))
      running = false
    })
  }

  window.addEventListener('resize', doItViaRAF)
}


export function handleResize() {
  mobileVpWidth = window.innerWidth

  if ((mobileVpWidth >= mobileSwapWidth) && isVisible) {
    toggleNav(event)
  }
}


export function determineEventLoc(event) {
  if (isVisible) {
    if (event.target === navEl) {
      return
    } else {
      for (let i = 0; i < allDesc.length; i++) {
        if (event.target === allDesc[i]) {
          return
        }
      }
    }
    toggleNav(event)
  } else {
    return
  }
}


export function handleKeyPresses(event) {
  if (isVisible && (event.keyCode === 27)) {
    toggleNav(event)
  }
}


export function toggleNav(event) {
  wrapEl.classList.toggle('is-visible')
  isVisible = !isVisible
  event.stopPropagation()
}
